export const environment = {
  production: false,
  apiUrl: 'https://github-edgelegalsystem.dev.falconsystem.com/api/v1'
};
